import { HOTSPOTS, MODULES, VEILIGHEIDSUITDAGINGEN } from '../content/content'
import { PRODUCTEN } from '../producten/catalogus'

/**
 * Leesbare namen voor de doelen uit `kiosk/meting.ts`: `tegel:automatisering`
 * wordt "Tegel Automatisering". Een doel dat hier niet bij staat, blijft
 * zoals het is — liever een technische naam dan een tik die wegvalt.
 */

const module = (id: string) => MODULES.find((m) => m.id === id)?.naam.nl ?? id

const ENERGIEVELDEN: Record<string, string> = {
  trucks: 'aantal trucks',
  shifts: 'shifts per dag',
  uren: 'draaiuren',
  laadtijd: 'laadtijd',
}

export function naamVan(doel: string): string {
  const [soort, a, b] = doel.split(':')
  switch (soort) {
    case 'tegel': return `Tegel ${module(a)}`
    case 'terug': return 'Terug naar het hoofdscherm'
    case 'keuze': {
      if (a === 'automatisering') return `Automatisering · ${HOTSPOTS.find((h) => h.id === b)?.truck ?? b}`
      if (a === 'veiligheid') return `Veiligheid · ${VEILIGHEIDSUITDAGINGEN.find((v) => v.id === b)?.oplossing ?? b}`
      return `${module(a)} · ${b}`
    }
    case '3d': return `3D-viewer · ${PRODUCTEN.find((p) => p.id === a)?.naam ?? a}`
    case 'film': return `Film · ${a}`
    case 'taal': return a === 'en' ? 'Taal naar Engels' : 'Taal naar Nederlands'
    case 'energie': return `Energiecalculator · ${ENERGIEVELDEN[a] ?? a}`
    default: return doel
  }
}

/** De groep waarin een doel valt, voor de verdeling per onderdeel. */
export function onderdeelVan(doel: string): string | null {
  const [soort, a] = doel.split(':')
  if (soort === 'tegel') return module(a)
  return null
}
